import React from 'react';
import { get } from 'lodash';
import Grid from '@lendi-ui/grid';

import { useFormValues } from '@funnels/hooks';

import { FullWidth } from '../../../_common';
import { DatePickerInputField } from '../../../Fields';
import { FunnelViewProps } from '../../types';
import { NeedsAndAnalysisCommon } from '../NeedsAndAnalysisCheckboxVariationCustomerView';
import { validateEndDate, validateStartDate } from './utils';

interface NeedsAndAnalysisDatesTeamViewProps extends FunnelViewProps {
  startDate: NeedsAndAnalysisCommon;
  endDate?: NeedsAndAnalysisCommon;
  validate?: (value: any) => string | undefined;
}

export const NeedsAndAnalysisDatesTeamView: React.FC<NeedsAndAnalysisDatesTeamViewProps> = (props) => {
  const { startDate, endDate, validate, isDisabled } = props;
  const [formValues] = useFormValues();
  const startDateValue = get(formValues, startDate.name);

  return (
    <FullWidth>
      <Grid gutter="sm" wrap={{ xs: true, md: false }}>
        <Grid.Unit>
          <DatePickerInputField {...startDate} isDisabled={isDisabled} validate={validate || validateStartDate} />
        </Grid.Unit>
        {endDate && (
          <Grid.Unit>
            <DatePickerInputField
              key={`from-${startDateValue}`}
              isDisabled={isDisabled}
              {...endDate}
              validate={validateEndDate(startDateValue, endDate.isOptional)}
            />
          </Grid.Unit>
        )}
      </Grid>
    </FullWidth>
  );
};
